export const permissionReducer = (state = {}, action) => {
  switch (action.type) {
    case "SET_PERMISSION":
      return action.payload;
    case "CLEAR_PERMISSION":
      return action.payload;
    default:
      return state;
  }
};
